import Gooey, { calc, Component, Dyn, dynGet, field } from '@srhazi/gooey';

import './KeyboardKey.css';

export const KeyboardKey: Component<{
    active: Dyn<boolean>;
    hue: string;
    saturation: string;
    key: string;
    label: Dyn<string>;
    isPressed: Dyn<boolean>;
    onMouseDown: () => void;
    onMouseUp: () => void;
}> = (
    { active, key, label, isPressed, hue, saturation, onMouseDown, onMouseUp },
    { onMount }
) => {
    return (
        <div
            cssprop:hue={hue}
            cssprop:saturation={saturation}
            on:mousedown={onMouseDown}
            on:mouseup={onMouseUp}
            class={calc(() => {
                const classes = ['KeyboardKey'];
                if (dynGet(isPressed)) {
                    classes.push('KeyboardKey--pressed');
                }
                if (!dynGet(active)) {
                    classes.push('KeyboardKey--inactive');
                }
                return classes.join(' ');
            })}
        >
            {label}
        </div>
    );
};
